import { useState, useEffect } from 'react';

/**
 * Hook to detect if the trial banner is visible
 * Used to adjust positioning of fixed/sticky elements
 */
export function useTrialBanner() {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    const checkBanner = () => {
      setIsVisible(window.isTrialBannerVisible === true);
    };
    
    // Initial check
    checkBanner();
    
    // Listen for changes with a short interval
    const interval = setInterval(checkBanner, 100);
    
    return () => clearInterval(interval);
  }, []);
  
  return {
    isVisible,
    bannerHeight: isVisible ? 40 : 0,
    topOffset: isVisible ? 'top-10' : 'top-0',
    paddingTop: isVisible ? 'pt-10' : 'pt-0',
    mobilePaddingTop: isVisible ? 'pt-[104px]' : 'pt-16',
  };
}